import { render, staticRenderFns } from "./user-manager.vue?vue&type=template&id=28f679b7&scoped=true&"
import script from "./user-manager.vue?vue&type=script&lang=js&"
export * from "./user-manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f679b7",
  null
  
)

export default component.exports